import { IconCaretRight } from '@/general/Icons/IconCaretRight';
import { Button } from '@/general/components/Button/Button';
import { Carousel } from '@/general/components/Carousel/Carousel';
import { ConditionalWrapper } from '@/general/components/ConditionalWrapper/ConditionalWrapper';
import { isEmpty } from '@/utils/isEmpty';
import { pushToDataLayer } from '@/utils/pushToDataLayer';
import { FC, ReactNode } from 'react';

interface CarouselTabCarsProps {
  /** Name used to track GTM events */
  carouselName?: string;
  /** Name used to track GTM events */
  carouselValue?: string;
  tiles: {
    id: string;
    tile: ReactNode;
  }[];
  footerBanner?: string;
  cta?: {
    label: ReactNode;
    url: string;
  };
}
const getCarouselTestId = (carouselName?: string) => {
  return carouselName ? `${carouselName}-carousel` : 'carousel';
};

const getFooterButtonTestId = (carouselName?: string, carouselValue?: string) => {
  if (!carouselName) return undefined;

  const baseId = `${carouselName}-carousel-browse-all`;
  return carouselValue ? `${baseId}-${carouselValue}` : `${baseId}-button`;
};

export const CarouselTabCars: FC<CarouselTabCarsProps> = ({
  tiles,
  footerBanner,
  cta,
  carouselName,
  carouselValue,
}) => {
  const hasFooterBanner = !isEmpty(footerBanner);
  return (
    <>
      <Carousel tiles={tiles} key={`${carouselValue}-${tiles.length}`} carouselName={getCarouselTestId(carouselName)} />
      {cta && (
        <footer className="flex justify-center px-8 pt-8 pb-0 md:pt-14">
          <ConditionalWrapper
            condition={hasFooterBanner}
            wrapper={(children) => (
              <div className="block w-full rounded-xs bg-bor-pri-lig/50 p-6 md:flex md:items-center md:justify-between md:gap-x-5">
                <div className="text-center text-2xl md:text-left">{footerBanner}</div>
                {children}
              </div>
            )}
          >
            <Button
              href={cta.url}
              variant={hasFooterBanner ? 'secondary' : 'primary'}
              size="medium"
              endIcon={<IconCaretRight />}
              data-testid={getFooterButtonTestId(carouselName, carouselValue)}
              onClick={() => {
                if (!isEmpty(carouselName) && !isEmpty(carouselValue)) {
                  pushToDataLayer({ event: 'carousel_footer_cta_click', name: carouselName, value: carouselValue });
                }
              }}
            >
              {cta.label}
            </Button>
          </ConditionalWrapper>
        </footer>
      )}
    </>
  );
};
